import { homeCmsIconMap as homeIconMap } from '@/utils/homeCmsIconMap';

export const getHomeIcon = (name) => {
  if (!name) return null;
  return homeIconMap[name] || null;
};

export default homeIconMap;
